import "./assets/css/fonts.css";
import "./index.css";
import "./assets/css/variables.css";

import React from "react";
import SupportView from "./components/SupportView/SupportView.js";
import logo from "./assets/images/logo.svg";
import restPropertiesService from "./services/RestPropertiesService";

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    var service = restPropertiesService(this.state);

    service.then((res) => {
      this.setState({ deploy: res });
    });
  }

  render() {
    return (
      <div className="app-container">
        <div className="app-header">
          <div className="app-wrapper app-logo">
            <img src={logo} alt="Logo OZG-Hub" />
          </div>
        </div>

        <div className="app-wrapper app-component-wrapper">
          <SupportView />
        </div>
        <div className="app-footer">
          <div className="app-footer-banner"></div>
          <div className="app-footer-links app-wrapper">
            <a title="Impressum" href={this.state.deploy + "impressum"}>
              Impressum
            </a>
            <a title="Datenschutz" href={this.state.deploy + "datenschutzerklaerung"}>
              Datenschutz
            </a>
          </div>
        </div>
      </div>
    );
  }
}
